import type { ListingStatus } from "@nova-ai/shared"

export const RUN_STATUS_LABELS: Record<ListingStatus, string> = {
  open: "Open",
  importing: "Importing",
  imported_with_errors: "Imported with errors",
  imported: "Imported",
  failed: "Failed",
  cancelled: "Cancelled",
}
